package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class TreatmentCourse(
    val created_at: String? = null,
    val deleted_at: String? = null,
    val id: Int?,
    val is_finished: Int?,
    val name: String?,
    val updated_at: String? = null
)